/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { datat } from "../DataTableTemplatingDemo/data";
import Swal from "sweetalert2";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import workerAPI from "../../../../api/worker/worker_service";

const ModalAdd = ({ lgShow, setLgShow, dataForm, setDataForm, onSave }) => {
  const products = useSelector((state) => state.ProductsReducer);
  const setting = useSelector((state) => state.StoreReducer);
  const [showSubmenus, setShowSubmenus] = useState({});
  const [formItems, setFormItems] = useState([]);
  const { t, i18n } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // التحقق من أن جميع المنتجات تحتوي على الحقول المطلوبة
    for (let i = 0; i < formItems.length; i++) {
      const item = formItems[i];
      if (!item.name || item.name === "" || item.price <= 0) {
        await Swal.fire({
          title: t("orderDetails.orderForm.alerts.incompleteProduct.title"),
          text: t("orderDetails.orderForm.alerts.incompleteProduct.text"),
          icon: "error",
          confirmButtonText: t(
            "orderDetails.orderForm.alerts.incompleteProduct.confirmButton"
          ),
          confirmButtonColor: "#8d5da7",
        });
        return; // إيقاف التنفيذ إذا كان هناك حقل غير مكتمل
      }
    }

    const updatedProducts = [...dataForm?.products, ...formItems];
    const finalTotal =
      updatedProducts?.reduce((acc, item) => {
        return acc + item.price * item.quantity;
      }, 0) + parseFloat(dataForm.deliveryPrice || 0);
    const { timeStamp, statusTimeline, ...otherFields } = dataForm;

    const updatedDataForm = {
      ...otherFields,
      timeStamp,
      statusTimeline: Array.isArray(statusTimeline) ? statusTimeline : [],
      products: updatedProducts,
      total: finalTotal,
    };

    try {
      if (!dataForm.id) {
        await workerAPI.createOrder(updatedDataForm);

        Swal.fire({
          icon: "success",
          title: t("success"),
          text: t("orderDetails.create_success"),
          confirmButtonText: t("ok"),
          timer: 3000,
          timerProgressBar: true,
        });
      } else {
        await workerAPI.updateOrder(dataForm.id, updatedDataForm);
        if (typeof onSave === "function") {
          onSave(updatedDataForm);
        }
        Swal.fire({
          icon: "success",
          title: t("success"),
          text: t("orderDetails.update_success"),
          confirmButtonText: t("ok"),
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error saving order:", error);

      Swal.fire({
        icon: "error",
        title: t("error"),
        text:
          error.response?.data?.message ||
          error.message ||
          t("orderDetails.save_error"),
        confirmButtonText: t("ok"),
      });
    }
    setLgShow(false);
    setFormItems([]);
  };

  const toggleSubmenu = (productId) => {
    setShowSubmenus((prevShowSubmenus) => ({
      ...prevShowSubmenus,
      [productId]: !prevShowSubmenus[productId],
    }));
  };

  const addFormItem = () => {
    setFormItems([
      ...formItems,
      {
        image: "",
        name: "",
        options: { offer: "", color: "", size: "" },
        price: 0,
        quantity: 1,
        sku: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const newFormItems = [...formItems];

    if (field === "productId") {
      const selectedProduct = products.find((product) => product.id === value);
      if (selectedProduct) {
        newFormItems[index] = {
          ...newFormItems[index],
          name: selectedProduct.name,
          image: selectedProduct.image,
          price: parseInt(selectedProduct.price),
          sku: selectedProduct.sku,
        };
      }
    } else if (field.startsWith("options.")) {
      const optionField = field.split(".")[1];

      newFormItems[index] = {
        ...newFormItems[index],
        options: {
          ...newFormItems[index].options,
          [optionField]: value,
        },
      };
    } else {
      newFormItems[index] = {
        ...newFormItems[index],
        [field]: value,
      };
    }

    setFormItems(newFormItems);
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;

    const statesList =
      setting.country === "الجزائر"
        ? setting.delevery.states
        : setting.country === "مصر"
        ? setting?.delevery?.states2
        : [];
    const selectedStateData = statesList.find(
      (state) => state.name === selectedState
    );

    const price = selectedStateData ? selectedStateData.price : "";

    setDataForm({
      ...dataForm,
      state: selectedState,
      deliveryPrice: price,
    });
  };

  useEffect(() => {
    // حساب مجموع أسعار المنتجات الموجودة في formItems
    const currentItemsTotal = formItems?.reduce((acc, item) => {
      return acc + item.price * item.quantity;
    }, 0);

    // حساب مجموع أسعار المنتجات الموجودة مسبقًا في dataForm?.products
    const previousItemsTotal = dataForm?.products?.reduce((acc, product) => {
      return acc + product.price * product.quantity;
    }, 0);

    // حساب السعر الإجمالي
    const total =
      currentItemsTotal +
      previousItemsTotal +
      parseFloat(dataForm.deliveryPrice || 0);

    // تحديث total في dataForm
    setDataForm((prevDataForm) => ({
      ...prevDataForm,
      total,
    }));
  }, [formItems, dataForm?.products, dataForm.deliveryPrice]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
  };

  const options = products.map((product) => ({
    value: product.id,
    label: (
      <div className="flex items-center">
        <img
          src={product.image || ""}
          className="w-6 h-6 rounded-full mr-2"
          alt={t("ship.product")}
        />
        {product.name}
      </div>
    ),
  }));

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...dataForm.products];

    // Ensure quantity is at least 1
    if (field === "quantity" && value < 1) {
      value = 1;
    }

    if (field.startsWith("options.")) {
      const optionField = field.split(".")[1];
      updatedProducts[index].options[optionField] = value;
    } else {
      updatedProducts[index][field] = value;
    }

    setDataForm({
      ...dataForm,
      products: updatedProducts,
    });
  };
  const handleDecrease = () => {
    onQuantityChange(quantity - 1);
  };

  const handleIncrease = () => {
    onQuantityChange(quantity + 1);
  };
  const [quantity, setQuantity] = useState(0);

  const handleQuantityChange = (newQuantity) => {
    setQuantity(newQuantity < 0 ? 0 : newQuantity); // Prevent negative values
  };

  return (
    <Modal
      size="lg"
      show={lgShow}
      onHide={() => setLgShow(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      className="w-100"
    >
      {!!setting.id && (
        <Form onSubmit={handleSubmit}>
          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-lg">
              {t("orderDetails.orderForm.title")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-center text-white fr-b">
              <b>{t("orderDetails.orderForm.orderProducts")}</b>
            </p>
            {dataForm?.products && dataForm?.products.length === 0 ? (
              <div className="text-center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/7486/7486747.png"
                  alt={t("orderDetails.orderForm.noDataAlt")}
                  className="w-20 h-20 mx-auto"
                />
                <br></br>
              </div>
            ) : (
              dataForm?.products &&
              dataForm?.products.map((product, index) => (
                <div className="mx-auto py-0 md:px-2 relative" key={index}>
                  <div
                    className="d-flex justify-content-between w-100 p-1-2 border4 card"
                    onClick={() => toggleSubmenu(product.name)}
                  >
                    <li className="flex gap-4 items-center">
                      <img
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        className="w-10 h-10 rounded-full"
                        alt={product.name}
                      />
                      <div className="flex-1 text-left flex items-center gap-x-1 text-truncate1">
                        {product.name}
                      </div>
                      <input
                        type="number"
                        className="text-sm"
                        value={product.price}
                        placeholder={t(
                          "orderDetails.orderForm.product.pricePlaceholder"
                        )}
                        style={{ textAlign: "left", fontWeight: "700" }}
                        onChange={(e) =>
                          handleProductChange(index, "price", e.target.value)
                        }
                      />
                      <i
                        className={`bi ${
                          showSubmenus[product.name]
                            ? "bi-chevron-double-up"
                            : "bi-chevron-double-down"
                        }`}
                        style={{ color: "#45a788" }}
                      ></i>
                    </li>
                  </div>
                  <div
                    className={`submenu ${
                      showSubmenus[product.name] ? "open" : ""
                    }`}
                  >
                    <div className="w-100 p-1-2 border4">
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.orderForm.product.offer")}
                        </p>
                        <input
                          type="text"
                          className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                          value={product?.options?.offer}
                          placeholder={t(
                            "orderDetails.orderForm.product.pricePlaceholder"
                          )}
                          style={{ textAlign: "left", fontWeight: "700" }}
                          onChange={(e) =>
                            handleProductChange(
                              index,
                              "options.offer",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <hr className="m-0 p-0" />
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.orderForm.product.color")}
                        </p>
                        <input
                          type="text"
                          className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                          value={product?.options?.color}
                          placeholder={t(
                            "orderDetails.orderForm.product.pricePlaceholder"
                          )}
                          style={{ textAlign: "left", fontWeight: "700" }}
                          onChange={(e) =>
                            handleProductChange(
                              index,
                              "options.color",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <hr className="m-0 p-0" />
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.orderForm.product.size")}
                        </p>
                        <input
                          type="text"
                          className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                          value={product?.options?.size}
                          placeholder={t(
                            "orderDetails.orderForm.product.pricePlaceholder"
                          )}
                          style={{ textAlign: "left", fontWeight: "700" }}
                          onChange={(e) =>
                            handleProductChange(
                              index,
                              "options.size",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <hr className="m-0 p-0" />
                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.orderForm.product.quantity")}
                        </p>
                        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                          <div
                            onClick={() =>
                              handleProductChange(
                                index,
                                "quantity",
                                product.quantity - 1
                              )
                            }
                          >
                            <i
                              className="bi bi-dash-circle"
                              style={{ fontSize: "24px" }}
                            ></i>
                          </div>
                          <input
                            type="text"
                            className="w-full py-2 px-3 text-gray-500 bg-transparent outline-none border-none m-0 text-success"
                            value={product.quantity}
                            placeholder={t(
                              "orderDetails.orderForm.product.pricePlaceholder"
                            )}
                            style={{
                              width: "20px",
                              textAlign: "center",
                              fontWeight: "700",
                            }}
                            onChange={(e) =>
                              handleProductChange(
                                index,
                                "quantity",
                                parseInt(e.target.value)
                              )
                            }
                          />
                          <div
                            onClick={() =>
                              handleProductChange(
                                index,
                                "quantity",
                                product.quantity + 1
                              )
                            }
                          >
                            <i
                              className="bi bi-plus-circle"
                              style={{ fontSize: "24px" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                    className="absolute top-0 left-0 p-1"
                    style={{
                      backgroundColor: "rgba(69, 167, 77, 0)",
                      marginTop: "-11px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <i
                      className="bi bi-x-circle"
                      style={{ color: "red", fontSize: "18px" }}
                      onClick={async (e) => {
                        e.stopPropagation();

                        if (dataForm?.products.length + formItems.length > 1) {
                          Swal.fire({
                            title: t(
                              "orderDetails.orderForm.product.deleteConfirmTitle"
                            ),
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#d33",
                            cancelButtonColor: "#6c757d",
                            confirmButtonText: t(
                              "orderDetails.orderForm.product.deleteConfirmButton"
                            ),
                            cancelButtonText: t(
                              "orderDetails.orderForm.product.deleteCancelButton"
                            ),
                          }).then(async (result) => {
                            if (result.isConfirmed) {
                              try {
                                const productToRemove = product;
                                let updatedTotal = dataForm.total;

                                if (
                                  dataForm?.products.some(
                                    (p) => p.name === product.name
                                  )
                                ) {
                                  const updatedProducts =
                                    dataForm?.products.filter(
                                      (p) => p.name !== product.name
                                    );

                                  updatedTotal -=
                                    product.price * product.quantity;

                                  await workerAPI.updateOrder(dataForm.id, {
                                    products: updatedProducts,
                                    total: updatedTotal,
                                  });

                                  setDataForm({
                                    ...dataForm,
                                    products: updatedProducts,
                                    total: updatedTotal,
                                  });
                                } else if (
                                  formItems.some((p) => p.name === product.name)
                                ) {
                                  const updatedFormItems = formItems.filter(
                                    (p) => p.name !== product.name
                                  );

                                  updatedTotal -=
                                    product.price * product.quantity;

                                  setFormItems(updatedFormItems);
                                  setDataForm({
                                    ...dataForm,
                                    total: updatedTotal,
                                  });
                                }

                                Swal.fire(
                                  t(
                                    "orderDetails.orderForm.product.deleteSuccessTitle"
                                  ),
                                  t(
                                    "orderDetails.orderForm.product.deleteSuccessMessage"
                                  ),
                                  "success"
                                );
                              } catch (error) {
                                console.error("Error removing product:", error);

                                Swal.fire(
                                  t("error"),
                                  error.response?.data?.message ||
                                    error.message ||
                                    t(
                                      "orderDetails.orderForm.product.deleteErrorMessage"
                                    ),
                                  "error"
                                );
                              }
                            }
                          });
                        } else {
                          alert(
                            t(
                              "orderDetails.orderForm.product.deleteLastProductWarning"
                            )
                          );
                        }
                      }}
                    ></i>
                  </span>
                </div>
              ))
            )}
            <div className="row mx-2">
              <div>
                {formItems.map((item, index) => (
                  <div key={index} className="row mb-3">
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formProduct${index}`}
                    >
                      <Select
                        value={options.find(
                          (option) => option.value === item.productId
                        )}
                        onChange={(selectedOption) => {
                          handleChange(
                            index,
                            "productId",
                            selectedOption.value
                          );
                        }}
                        options={options}
                        styles={customStyles}
                        placeholder={t(
                          "orderDetails.orderForm.product.selectProduct"
                        )}
                        isSearchable
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formQty${index}`}
                    >
                      <Form.Control
                        type="number"
                        placeholder={t(
                          "orderDetails.orderForm.product.quantity"
                        )}
                        value={item.quantity || ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "quantity",
                            parseInt(e.target.value)
                          )
                        }
                        className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                        required
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formTotal${index}`}
                    >
                      <Form.Control
                        type="number"
                        placeholder={t("orderDetails.orderForm.product.price")}
                        value={item.price || ""}
                        onChange={(e) =>
                          handleChange(index, "price", parseInt(e.target.value))
                        }
                        className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                        required
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 col-12 col-sm-3"
                      controlId={`formoptions${index}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder={t(
                          "orderDetails.orderForm.product.notePlaceholder"
                        )}
                        value={item.options.offer}
                        onChange={(e) =>
                          handleChange(index, "options.offer", e.target.value)
                        }
                        className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                      />
                    </Form.Group>
                  </div>
                ))}

                <div className="row">
                  <Button
                    onClick={addFormItem}
                    variant="outline-primary"
                    className="ant-btn text-white css-dev-only-do-not-override-19gw05y ant-btn-primary ant-btn-lg hp-bg-warning-1 hp-border-color-warning-1 hp-hover-bg-warning-2 hp-hover-border-color-warning-2"
                  >
                    {t("orderDetails.orderForm.addProduct")}
                  </Button>
                </div>
              </div>
            </div>
            <p className="text-center text-white fr-b">
              <b>{t("orderDetails.orderForm.clientInfo")}</b>
            </p>
            <div className="row mx-2">
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicEmail"
              >
                <Form.Control
                  type="text"
                  placeholder={t("orderDetails.orderForm.namePlaceholder")}
                  value={dataForm.name}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, name: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicPhone"
              >
                <Form.Control
                  type="text"
                  placeholder={t("orderDetails.orderForm.phonePlaceholder")}
                  value={dataForm?.isValid ? "********" : dataForm.phone} // Show asterisks if dataForm.isValid is true
                  onChange={(e) => {
                    if (!dataForm?.isValid) {
                      // Only allow changes if dataForm.isValid is false
                      setDataForm({ ...dataForm, phone: e.target.value });
                    }
                  }}
                  className={`w-full inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-purple-400 focus:ring-2 ${
                    dataForm?.isValid ? "border-red-500" : ""
                  }`}
                  disabled={dataForm?.isValid} // Disable input if either isValid is true
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicState"
              >
                {setting.country === "الجزائر" ? (
                  <Form.Select
                    required
                    placeholder={t("orderDetails.orderForm.state.dz")}
                    value={dataForm.state}
                    onChange={handleStateChange}
                    className="w-full text-right inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                  >
                    <option value="">
                      {t("orderDetails.orderForm.state.dz")}
                    </option>

                    {setting.delevery.paid &&
                      setting.delevery.states
                        .filter((state) => state.hide)
                        .map((state) => (
                          <option key={state.wilaya_code} value={state.name}>
                            {state.name}
                          </option>
                        ))}

                    {setting.delevery.free &&
                      setting.delevery.states.map((state) => (
                        <option key={state.wilaya_code} value={state.name}>
                          {state.name}
                        </option>
                      ))}
                  </Form.Select>
                ) : setting.country === "مصر" ? (
                  <Form.Select
                    required
                    placeholder={t("orderDetails.orderForm.state.eg")}
                    value={dataForm.state}
                    onChange={handleStateChange}
                    className="w-full inline-flex items-center text-right justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                  >
                    <option value="">
                      {t("orderDetails.orderForm.state.eg")}
                    </option>
                    {setting.delevery.paid &&
                      setting?.delevery?.states2
                        .filter((state) => state.hide)
                        .map((state) => (
                          <option key={state.wilaya_code} value={state.name}>
                            {state.name}
                          </option>
                        ))}

                    {setting.delevery.free &&
                      setting?.delevery?.states2.map((state) => (
                        <option key={state.wilaya_code} value={state.name}>
                          {state.name}
                        </option>
                      ))}
                  </Form.Select>
                ) : (
                  <Form.Control
                    placeholder={t("orderDetails.orderForm.state.eg")}
                    value={dataForm.state}
                    onChange={(e) =>
                      setDataForm({ ...dataForm, state: e.target.value })
                    }
                    className="w-full inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                  />
                )}
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicCommune"
              >
                {setting?.delevery?.activeCities &&
                  setting.country === "الجزائر" && (
                    <Form.Select
                      required
                      dir={i18n.dir()}
                      placeholder={t("orderDetails.orderForm.commune.dz")}
                      disabled={!dataForm.state}
                      value={dataForm.commune}
                      onChange={(e) =>
                        setDataForm({ ...dataForm, commune: e.target.value })
                      }
                      className="w-full inline-flex text-right items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2 "
                    >
                      <option value="">
                        {t("orderDetails.orderForm.commune.dz")}
                      </option>
                      {datat
                        .filter((wliya) => wliya.wilaya_name === dataForm.state)
                        .map((state) => (
                          <option
                            key={state.commune_name}
                            value={state.commune_name}
                          >
                            {state.commune_name}
                          </option>
                        ))}
                    </Form.Select>
                  )}
                {setting?.delevery?.activeCities &&
                  setting?.country === "مصر" && (
                    <Form.Control
                      required
                      placeholder={t("orderDetails.orderForm.commune.eg")}
                      disabled={!dataForm.state}
                      value={dataForm.commune}
                      onChange={(e) =>
                        setDataForm({ ...dataForm, commune: e.target.value })
                      }
                      className="w-full inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                    />
                  )}
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicAddress"
              >
                <Form.Control
                  type="text"
                  placeholder={t("orderDetails.orderForm.addressPlaceholder")}
                  value={dataForm.address}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, address: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-4"
                controlId="formBasicAddress"
              >
                <Form.Control
                  type="text"
                  placeholder={t("orderDetails.orderForm.orderNotePlaceholder")}
                  value={dataForm.note}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, note: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-6"
                controlId="formBasicDeliveryPrice"
              >
                <Form.Control
                  type="text"
                  placeholder={t(
                    "orderDetails.orderForm.deliveryPricePlaceholder"
                  )}
                  value={dataForm.deliveryPrice || ""}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, deliveryPrice: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <Form.Group
                className="mb-3 col-12 col-sm-6"
                controlId="formBasicTotalPrice"
              >
                <Form.Control
                  type="text"
                  placeholder={t(
                    "orderDetails.orderForm.totalPricePlaceholder"
                  )}
                  value={dataForm.total || ""}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, total: e.target.value })
                  }
                  className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"
                />
              </Form.Group>
              <div className="d-flex align-items-center">
                <Form.Check
                  inline
                  name="group1"
                  type={"checkbox"}
                  className="mx-2"
                  checked={dataForm.stopdeskDelivery}
                  onChange={(e) =>
                    setDataForm({
                      ...dataForm,
                      stopdeskDelivery: !dataForm.stopdeskDelivery,
                    })
                  }
                />
                <p className="mb-0">
                  {" "}
                  {t("orderDetails.orderForm.stopdeskDelivery")}
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              variant="secondary"
              onClick={() => {
                setLgShow(false);
                setFormItems([]);
              }}
              className="w-full mt-2 p-2.5 flex-1 text-gray-800 rounded-md outline-none border ring-offset-2 ring-indigo-600 focus:ring-2"
            >
              {t("orderDetails.orderForm.close")}
            </button>
            <button
              type="submit"
              variant="primary"
              className="w-full mt-2 p-2.5 flex-1 text-white bg-[#9b59bf] rounded-md outline-none ring-offset-2 ring-indigo-600 focus:ring-2 "
            >
              {t("orderDetails.orderForm.save")}
            </button>
          </Modal.Footer>
        </Form>
      )}
    </Modal>
  );
};

export default ModalAdd;
